import { Component, Host, Prop, State, h } from '@stencil/core';

@Component({
  shadow: true,
  styleUrl: 'supporting-text.css',
  tag: 'abds-supporting-text',
})
export class SupportingText {
  // --------------------------------------------------------------------------
  //
  //  Props
  //
  // --------------------------------------------------------------------------

  /** Error message text. **Note:** Error text will always override helper text. */
  @Prop({ reflect: true }) errorText: string;

  /** Helper/informational message text. */
  @Prop({ reflect: true }) helperText: string;

  //--------------------------------------------------------------------------
  //
  //  Private State
  //
  //--------------------------------------------------------------------------

  @State() messageType: 'error' | 'information' | null = null;

  // --------------------------------------------------------------------------
  //
  //  Lifecycle Methods
  //
  // --------------------------------------------------------------------------

  componentWillRender() {
    if (this.errorText) this.messageType = 'error';
    else if (this.helperText) this.messageType = 'information';
    else this.messageType = null;
  }

  render() {
    /** there are two separate span elements to accommodate the ease-in transition */
    return (
      <Host>
        <span class={{ active: this.messageType === 'error', 'error-text': true }}>{this.errorText}</span>
        <span class={{ active: this.messageType !== 'error', 'default-text': true }}>{this.helperText}</span>
      </Host>
    );
  }
}
